const firebaseConfig = {
  apiKey: "AIzaSyA3re_ymPrkFyja01sj7Rl4H_o1A5wetQc",
  authDomain: "ww-titans-26fbe.firebaseapp.com",
  projectId: "ww-titans-26fbe",
  storageBucket: "ww-titans-26fbe.firebasestorage.app",
  messagingSenderId: "607258175921",
  appId: "1:607258175921:web:a9b9399e1c1d979134f590",
  measurementId: "G-8EX1206CNH"
};

  

export default firebaseConfig;
